@import "@/scss/use-bootstrap-mixins.scss";

.root {
  border-radius: 8px;
  border: none;

  font-weight: 500;

  &:hover {
    cursor: pointer;
  }

  /**
    *
    *   Button themes
    *
    */
  &.primary {
    background-color: $primary;
    color: $textColorOnPrimary;
    border: 2px solid $primary;
  }

  &.textOnPrimary {
    background-color: #fff;
    color: #000;
    border: 2px solid #fff;
  }

  &.outlineOnPrimary {
    background-color: transparent;
    border: 2px solid $textColorOnPrimary;
    color: $textColorOnPrimary;
  }

  &.outlineOnBackground {
    background-color: transparent;
    border: 2px solid $primaryOnBackground;
    color: $primaryOnBackground;
  }

  &.primaryOnWhite {
    background-color: #fff;
    border: 2px solid #fff;
    color: $primaryOnBackground;
  }

  &.black {
    // solid black button
    background-color: #000;
    border: 1px solid #000;
    color: #fff;
  }

  &.blackOnWhite {
    // legacy variant keep behaviour but update border width
    background-color: #fff;
    border: 1px solid #000;
    color: #000;
  }

  &.outlinePrimaryOnWhite {
    background-color: #fff;
    color: $primary;
    border: 1px solid $primary;
  }

  &.outlineBlack {
    background-color: #fff;
    border: 2px solid #000;
    color: #000;
  }

  /**
    *
    *   Button sizes
    *
    */
  &.small {
    padding: 10px 14px;
    font-size: 14px;
  }

  &.medium {
    padding: 10px;
    width: 100%;
    font-size: 16px;

    @include iPhoneX {
      padding: 14px;
    }
  }

  &.large {
  }

  &.chevronLeft {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      flex: 1;
    }

    svg {
      path {
        stroke: $primaryOnBackground;
      }
    }
  }

  &:disabled {
    opacity: 0.5;
  }
}
